import * as Yup from "yup";

export const ticketValidate = Yup.object().shape({
  title: Yup.string().required("وارد کردن عنوان پیام الزامی است"),
  department: Yup.string().required("وارد کردن  بخش مربوطه الزامی است"),
  message: Yup.string().required("وارد کردن پیام الزامی است"),
});
